export const Gmap = (props) => {
    return (
        <div id='gmap' className='text-center'>
            <div className='map'>
                <iframe title={props.data ? props.data.title : 'Loading'} width={props.data ? props.data.section_width : 'Loading'} height={props.data ? props.data.section_height : 'Loading'} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=MIla%20Pantica%2014+(Alpa%20Nautic)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe></div>
            </div>
    )
}